module.exports = __webpack_public_path__ + "img/system28-mini.329abd89.png";